import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import projectExpirationReportComponent from './project-expiration-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let projectExpirationReportModule = angular.module('projectexpirationreport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('projectexpirationreport', {
    parent: 'app',
    url: '/admin/reports/projectexpiration',
    data: {
      pageHeader: true,
      pageTitle: 'Project Expiration Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<projectexpirationreport></projectexpirationreport>'
  });

})

.component('projectexpirationreport', projectExpirationReportComponent);

export default projectExpirationReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/project-expiration-report/project-expiration-report.js